// plus icon 

export default function PlusIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path d="M21.1667 11.4199H12.8334V3.0865C12.8334 2.62626 12.4603 2.25317 12 2.25317C11.5398 2.25317 11.1667 2.62626 11.1667 3.0865V11.4198H2.83334C2.3731 11.4199 2.00002 11.793 2.00002 12.2532C2.00002 12.7134 2.3731 13.0865 2.83334 13.0865H11.1667V21.4199C11.1667 21.8801 11.5398 22.2532 12 22.2532C12.4602 22.2532 12.8333 21.8801 12.8333 21.4199V13.0865H21.1667C21.6269 13.0865 22 12.7134 22 12.2532C22.0001 11.793 21.627 11.4199 21.1667 11.4199Z" fill="#006AFF"/>
        </svg>
    );
}